import styled, { css, keyframes } from "styled-components";
import { motion } from "motion/react";

// TypeScript Interface for background icon data structure
interface BackgroundIcon {
  iconSrc: string;
  name: string;
  link?: string; // Optional - some icons may not have links
}

// TypeScript Interface for the animated invite icon container
interface BackgroundInviteIconContainerProps {
  playAnimation: boolean;
}

// Keyframe animations
const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
`;

// Styled Components
export const BackgroundIcons = styled.div`
  display: flex;
  width: 250px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  padding: 10px;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 20px;
`;

export const BackgroundIconContainer = styled(motion.a)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: fit-content;
  cursor: pointer;
  width: 70px;
  text-decoration: none;
  color: ${(props) => props.theme.black};
`;

export const BackgroundIcon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  object-position: center;
`;

export const BackgroundIconName = styled.div`
  font-size: ${(props) => props.theme.fontNormal}px;
  width: 80%;
  text-align: center;
`;

export const BackgroundInviteIconContainer = styled.div<BackgroundInviteIconContainerProps>`
  display: flex;
  gap: 4px;
  width: 70px;
  font-size: ${(props) => props.theme.fontNormal}px;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  background: none;
  border: none;
  ${(props) =>
    !props.playAnimation &&
    css`
      animation: ${pulse} 2s ease-in-out infinite;
    `};

  &:hover {
    animation: ${pulse} 1s ease-in-out infinite;
  }
`;

export const BackgroundInviteIcon = styled.img`
  width: 40px;
  height: 40px;
`;
